import { Link } from "react-router-dom";
import ScrollReveal from "@/components/base/ScrollReveal";

export default function IntroSection() {
  return (
    <section className="w-full bg-background-50 py-20 md:py-28">
      <div className="mx-auto w-full max-w-7xl px-6 md:px-12 lg:px-20">
        <div className="grid grid-cols-1 items-center gap-12 lg:grid-cols-2 lg:gap-20">
          <ScrollReveal>
            <span className="font-label text-xs tracking-[0.4em] text-secondary-500">ABOUT US</span>
            <h2 className="mt-6 font-display text-2xl font-normal leading-[1.9] tracking-[0.04em] text-foreground-950 md:text-3xl lg:text-[34px]">
              事業を創る会社ではなく、
              <br />
              人の可能性を創る会社です。
            </h2>
            <div className="mt-8 flex flex-col gap-5 font-body text-[15px] leading-[2] text-foreground-700">
              <p>
                テクノロジーの進化や社会構造の変化により、世界はかつてないスピードで変わり続けています。
                しかし、どれだけ時代が変わっても、変革を起こし、新しい時代を創るのは、いつの時代も
                <strong className="font-medium text-foreground-950">「人」</strong>だと私たちは信じています。
              </p>
              <p>
                <strong className="font-medium text-foreground-950">REVRA Group</strong>の「REVRA」とは、Revolution（変革）と
                Era（時代）を掛け合わせた言葉。
                私たちが本当に目指すのは、事業の成功ではなく、一人ひとりの可能性が花開く社会を創ることです。
              </p>
            </div>
            <Link
              to="/company/message"
              className="mt-10 inline-flex items-center gap-3 whitespace-nowrap font-label text-sm tracking-[0.24em] text-foreground-950 transition-colors hover:text-accent-700"
            >
              FOUNDER MESSAGE
              <i className="ri-arrow-right-line" />
            </Link>
          </ScrollReveal>

          <ScrollReveal delay={150}>
            <div className="relative mx-auto w-full max-w-xs md:max-w-sm lg:ml-auto lg:mr-0">
              <div className="aspect-[4/5] w-full overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Atmospheric%20dark%20minimal%20interior%20of%20a%20modern%20office%20at%20dusk%2C%20glass%20reflections%20and%20soft%20silhouettes%2C%20monochrome%20with%20warm%20golden%20light%2C%20elegant%20corporate%20editorial%20photography%2C%20shallow%20depth%20of%20field%2C%20quiet%20and%20refined%20mood%2C%20high%20detail&width=1000&height=1250&seq=revra-intro-portrait&orientation=portrait"
                  alt="REVRA Group オフィスイメージ"
                  className="h-full w-full object-cover object-top"
                />
              </div>
            </div>
          </ScrollReveal>
        </div>
      </div>
    </section>
  );
}